import InventoryXLSX from "@assets/templates/Bulk_Inventory_Update_Template_File.xlsx";
import PriceUpdateXLSX from "@assets/templates/Bulk_Price_Update_Template_File.xlsx";
import ImageUpdateXLSX from "@assets/templates/Bulk_Product_Details_Update_Template_File.xlsx";
import ProductXLSX from "@assets/templates/Bulk_Product_Template_File.xlsx";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import IconButton from "@material-ui/core/IconButton";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import Paper from "@material-ui/core/Paper";
import { makeStyles } from "@material-ui/core/styles";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import DeleteIcon from "@material-ui/icons/Delete";
import ControlledCheckbox from "@saleor/components/ControlledCheckbox";
import SingleAutocompleteSelectField from "@saleor/components/SingleAutocompleteSelectField";
// import Typography from "@material-ui/core/Typography";
// import ConfirmButton, {
//   ConfirmButtonTransitionState
// } from "@saleor/components/ConfirmButton";
// import { MultiAutocompleteChoiceType } from "@saleor/components/MultiAutocompleteSelectField";
// import useForm, { FormChange } from "@saleor/hooks/useForm";
// import useModalDialogErrors from "@saleor/hooks/useModalDialogErrors";
// import useModalDialogOpen from "@saleor/hooks/useModalDialogOpen";
// import useWizard from "@saleor/hooks/useWizard";
import { buttonMessages } from "@saleor/intl";
import { ProductsUser } from "@saleor/products/customTypes/ProductsUser";
import useBrandUpdate from "@saleor/products/hooks/useBrandUpdate";
import { SearchBrands_search_edges_node } from "@saleor/searches/types/SearchBrands";
import { DialogProps } from "@saleor/types";
// import {
//   ExportProductsInput,
//   ExportScope,
//   FileTypesEnum
// } from "@saleor/types/globalTypes";
// import getExportErrorMessage from "@saleor/utils/errors/export";
// import { toggle } from "@saleor/utils/lists";
// import { mapNodeToChoice } from "@saleor/utils/maps";
import React, { useEffect, useState } from "react";
import Dropzone from "react-dropzone";
import { useIntl } from "react-intl";
import { FormattedMessage } from "react-intl";

// const initialForm: ExportProductsInput = {
//   exportInfo: {
//     attributes: [],
//     fields: [],
//     warehouses: []
//   },
//   fileType: FileTypesEnum.XLSX,
//   scope: ExportScope.ALL
// };

const useStyles = makeStyles(
  {
    descriptionLabel: {
      margin: "5px 0px 5px 0px"
    },
    fileUploadField: {
      height: "175px",
      paddingTop: "20px",
      textAlign: "center"
    },
    root: {
      display: "flex"
    }
  },
  { name: "ProductBulkUploadDialog" }
);

export interface ProductBulkUploadDialogProps extends DialogProps {
  action: string;
  loading: boolean;
  onFileError: () => void;
  onSubmit: (
    file: any,
    isOverwrite: boolean,
    productsUser?: ProductsUser,
    brand?: string
  ) => void;
  productsUser?: ProductsUser;
  brands?: SearchBrands_search_edges_node[];
}

const ProductBulkUploadDialog: React.FC<ProductBulkUploadDialogProps> = props => {
  const {
    action,
    onClose,
    onFileError,
    open,
    onSubmit,
    loading,
    productsUser,
    brands
  } = props;

  const classes = useStyles(props);
  const upload = React.useRef(null);
  const intl = useIntl();

  const [getFile, setFile] = useState(null);
  const [isOverwrite, setIsOverwrite] = useState(
    action !== "uploadBulkProduct"
  );

  useEffect(() => {
    if (!open) {
      setFile(null);
    }
  }, [open]);

  const headerText = thisAction => {
    switch (thisAction) {
      case "uploadBulkPrice":
        return (
          <FormattedMessage
            defaultMessage="Bulk Product Price Update"
            description="import products to csv file, dialog header"
          />
        );
      case "uploadBulkImage":
        return (
          <FormattedMessage
            defaultMessage="Bulk Product Details Upload"
            description="import products to csv file, dialog header"
          />
        );
      case "uploadBulkInventory":
        return (
          <FormattedMessage
            defaultMessage="Bulk Inventory Update"
            description="import products to csv file, dialog header"
          />
        );
      default:
        return (
          <FormattedMessage
            defaultMessage="Bulk Product"
            description="import products to csv file, dialog header"
          />
        );
    }
  };

  // Hook for updating of brands
  const [onBrandChange, brand, brandChoices] = useBrandUpdate(
    {},
    brands,
    false
  );

  const createLink = thisAction => {
    let message = "Download a {link} template file for bulk product update.";
    let thisLink = ProductXLSX;
    let filename = "Bulk_Product_Template_File.xlsx";
    switch (thisAction) {
      case "uploadBulkPrice":
        thisLink = PriceUpdateXLSX;
        filename = "Bulk_Price_Update_Template_File.xlsx";
        message =
          "Download a {link} template file for bulk price product update.";
        break;
      case "uploadBulkImage":
        thisLink = ImageUpdateXLSX;
        filename = "Bulk_Product_Details_Update_Template_File.xlsx";
        message =
          "Download a {link} template file for bulk image and description update.";
        break;
      case "uploadBulkInventory":
        thisLink = InventoryXLSX;
        filename = "Bulk_Inventory_Update_Template_File.xlsx";
        message = "Download a {link} template file for Bulk Inventory Update.";
        break;
    }
    return (
      <FormattedMessage
        id="text"
        defaultMessage={message}
        values={{
          link: (
            <a href={thisLink} download={filename} id="xlsxDownloadLink">
              <FormattedMessage id="link" defaultMessage="xlsx" />
            </a>
          )
        }}
      />
    );
  };

  const checkFile = e => {
    if (
      e[0].type !==
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    ) {
      onFileError();
    } else {
      setFile(e[0]);
    }
  };

  const handleClose = () => {
    onClose();
    setFile(null);
  };

  return (
    <Dialog
      onClose={handleClose}
      open={open}
      maxWidth="sm"
      fullWidth
      disableBackdropClick={loading}
    >
      <>
        <DialogTitle>{headerText(action)}</DialogTitle>
        <DialogContent>
          {productsUser.isKAMS && (
            <SingleAutocompleteSelectField
              label={intl.formatMessage({
                defaultMessage: "Seller (Brand)*"
              })}
              name="brandDropdown"
              displayValue={brand.label}
              choices={brandChoices}
              value={brand.value}
              onChange={onBrandChange}
            />
          )}
          {createLink(action)}
          {action === "uploadBulkProduct" && (
            <ControlledCheckbox
              name={"overwrite"}
              id="overwriteCheckbox"
              label={intl.formatMessage({
                defaultMessage: "Overwrite existing products",
                description: "check to require attribute to have value"
              })}
              checked={isOverwrite}
              onChange={() => setIsOverwrite(!isOverwrite)}
            />
          )}
          {getFile ? (
            <Paper>
              <List>
                <ListItem>
                  {getFile.name}
                  <ListItemSecondaryAction>
                    <IconButton
                      id="fileDeleteBtn"
                      edge="end"
                      aria-label="delete"
                      onClick={() => setFile(null)}
                    >
                      {loading ? (
                        <CircularProgress size={16} />
                      ) : (
                        <DeleteIcon />
                      )}
                    </IconButton>
                  </ListItemSecondaryAction>
                </ListItem>
              </List>
            </Paper>
          ) : (
            <Dropzone onDrop={checkFile}>
              {({ getRootProps, getInputProps }) => (
                <div {...getRootProps()}>
                  <Paper
                    className={classes.fileUploadField}
                    onClick={() => upload.current.click()}
                  >
                    <input
                      {...getInputProps()}
                      id="fileUpload"
                      accept=".xlsx"
                      onChange={e => checkFile(e.target.files)}
                      ref={upload}
                      type="file"
                      disabled={productsUser.isKAMS && !brand.value}
                    />
                    <CloudUploadIcon fontSize="large" />
                    <p className={classes.descriptionLabel}>
                      <FormattedMessage
                        defaultMessage="Drag and Drop Files"
                        description="description"
                      />
                    </p>
                    <p className={classes.descriptionLabel}>
                      <FormattedMessage
                        defaultMessage="Or"
                        description="description"
                      />
                    </p>
                    <Button
                      id="uploadAFileBtn"
                      color="primary"
                      variant="contained"
                      disabled={productsUser.isKAMS && !brand.value}
                    >
                      <FormattedMessage
                        defaultMessage="Upload a file"
                        description="description"
                      />
                    </Button>
                  </Paper>
                </div>
              )}
            </Dropzone>
          )}
        </DialogContent>

        {/* {notFormErrors.length > 0 && (
          <DialogContent>
            {notFormErrors.map(err => (
              <Typography color="error" key={err.field + err.code}>
                {getExportErrorMessage(err, intl)}
              </Typography>
            ))}
          </DialogContent>
        )} */}

        {getFile && !loading && (
          <DialogActions>
            <Button onClick={handleClose} data-test="cancel" id="cancelBtn">
              <FormattedMessage {...buttonMessages.cancel} />
            </Button>
            <Button
              id="productBulkUploadBtn"
              onClick={() =>
                onSubmit(getFile, isOverwrite, productsUser, brand.value)
              }
              color="primary"
              variant="contained"
              data-test="next"
            >
              <FormattedMessage {...buttonMessages.upload} />
            </Button>
          </DialogActions>
        )}
      </>
    </Dialog>
  );
};

ProductBulkUploadDialog.displayName = "ProductBulkUploadDialog";
export default ProductBulkUploadDialog;
